@charset "UTF-8";

/* src/app/account/digital-wallet/components/custom-paginator/custom-paginator.component.scss */
#outer {
  width: 100%;
  text-align: center;
  height: 80px;
  padding: 15px 25px 0px 0px;
  color: var(--ups-brand-colors-ups-blue, #0662BB);
  font-feature-settings: "clig" off, "liga" off;
  font-family: "Roboto Flex", sans-serif;
  font-size: 16px;
  font-style: normal;
  font-weight: 500;
  line-height: 24px;
}
.inner {
  display: inline-block;
  padding-inline-start: 8px;
}
.inner a {
  text-decoration: none;
}
.inner mat-select {
  width: 140px;
}
.inner span {
  content: "\203a";
}
.inner .arrow {
  font-size: x-large;
}
.inner .disabled-link {
  pointer-events: none;
  color: var(--ups-brand-colors-ups-grey-3, #BFB8AF);
  font-feature-settings: "clig" off, "liga" off;
  font-family: "Roboto Flex", sans-serif;
  font-size: 16px;
  font-style: normal;
  font-weight: 500;
  line-height: 24px;
}
/*# sourceMappingURL=custom-paginator.component.css.map */
